module.exports = __webpack_public_path__ + "img/1.47a4de81.jpg";